import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { SyncFieldFormInputService } from '../sync-field-form-input.service';

@Component({
  selector: 'crm-sync-icon',
  imports: [MatIcon, GalaxyPopoverModule, TranslateModule, AsyncPipe],
  templateUrl: './sync-icon.component.html',
  styleUrl: './sync-icon.component.scss',
})
export class SyncIconComponent {
  popoverShown = false;
  @Input() fieldId!: string;

  renderIcon$ = combineLatest([
    this.syncFieldFormInputService.hasAccount(),
    this.syncFieldFormInputService.getSyncFieldIds(),
  ]).pipe(
    map(([hasAccount, syncFieldIds]) => {
      const isSynced = syncFieldIds?.find((id) => id === this.fieldId);
      return hasAccount && isSynced;
    }),
  );

  constructor(
    private readonly router: Router,
    private readonly syncFieldFormInputService: SyncFieldFormInputService,
    private readonly changeDetector: ChangeDetectorRef,
  ) {}

  openAccount() {
    this.syncFieldFormInputService
      .getAccountId()
      .pipe(take(1))
      .subscribe((id) => {
        if (!id) {
          console.error('Could not find account id');
          return;
        }
        this.popoverShown = false;
        this.changeDetector.detectChanges();
        const crmURL = `businesses/accounts/${id}/details`;
        this.router.navigateByUrl(crmURL);
      });
  }
}
